import React from "react";
import BlogDetail from "@/components/pages/BlogDetail";
import getServer from "@/utils/functions/function";

const Blog = ({ data, dataHeader }) => {
  return (
    <BlogDetail data={data} dataHeader={dataHeader} />
  );
};

export default Blog;

export async function getServerSideProps(context) {
  return await getServer(context);
}


